import React, { useState } from 'react';

interface IProps {
  duration: number;
  currentTime: number;
  isThinkingTime: boolean;
  onChangeTime: (currentTime: number, playing: boolean) => void;
}

export const VideoTimeBar:React.FC<IProps> = ({
  duration, currentTime, isThinkingTime, onChangeTime,
}) => {
  const [isTimeChangeable, setIsTimeChangeable] = useState(false);
  const [indicatorPosition, setIndicatorPosition] = useState(0);
  const progress = (currentTime / duration) * 100;

  const handleIndicatorPosition = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const pos = ('pageX' in e ? e.pageX : e.targetTouches[0].pageX) - rect.left;
    const indicatorPos = Math.max(Math.min(99.9, (pos / rect.width) * 100), 0);
    setIndicatorPosition(indicatorPos);
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
    if (isThinkingTime) return;
    setIsTimeChangeable(true);
    handleIndicatorPosition(e);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
    if (isThinkingTime) return;
    handleIndicatorPosition(e);
  };

  const handleMouseUp = () => {
    if (isThinkingTime) return;
    if (isTimeChangeable) {
      onChangeTime(((indicatorPosition) / 100) * duration, true);
      setIsTimeChangeable(false);
    }
  };

  return (
    <div
      className={`myinterview-widget-video-question__time-bar ${isThinkingTime ? 'myinterview-widget-video-question__time-bar--disabled' : ''}`}
      role="presentation"
      onMouseDown={handleMouseDown}
      onTouchStart={handleMouseDown}
      onMouseMove={handleMouseMove}
      onTouchMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onTouchEnd={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <span
        className={`
        myinterview-widget-video-question__time-bar-progress
        ${isTimeChangeable ? 'myinterview-widget-video-question__time-bar-progress--changing' : ''}
        ${isThinkingTime ? 'myinterview-widget-video-question__time-bar-progress--unchangeable' : ''}
        `}
        style={{ width: `${isTimeChangeable ? indicatorPosition : progress}%` }}
      />
    </div>
  );
};
